import "@/helpers/turbo"

import EnquiryFormController from "../controllers/enquiry_form_controller"
import RecaptchaController from "../controllers/recaptcha_controller"
import { register } from "@/helpers/stimulus"

const setupStimulus = (): void => {
  register("enquiry-form", EnquiryFormController)
  register("recaptcha", RecaptchaController)
}

setupStimulus()
